import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import { ReactComponent as MapMarker } from '../../../../images/map-marker.svg';
import { ReactComponent as NavClassic } from '../../../../images/nav-classic.svg';
import { ReactComponent as NavCompare } from '../../../../images/nav-compare.svg';
import { ReactComponent as NavMarket } from '../../../../images/nav-market.svg';
import { ReactComponent as NavSearches } from '../../../../images/nav-searches.svg';
import useUsers from '../../../users/useUsers';
import useSubscription from '../../hooks/useSubscription';
import styles from './subscriptionContent.module.scss';

function SubscriptionContent() {
  const { userCount } = useUsers();
  const { totalAuthorizedUsers, subscription, subscriptionStatusPending } =
    useSubscription();

  const dataCount = `${userCount + 1}/${totalAuthorizedUsers}`;

  return (
    <div className={styles.container}>
      <h3>Nombre d&apos;utilisateurs autorisés</h3>

      {subscriptionStatusPending ? (
        <IndividualCircularLoader size={30} />
      ) : (
        <span className={styles.data}>{dataCount}</span>
      )}

      <ul className={styles.list}>
        <li className={styles.active}>
          <NavClassic />
          <span className="user-registration-text">Pige classique</span>
        </li>
        <li className={subscription?.hasComparativeStudy ? styles.active : ''}>
          <NavCompare />
          <span>Etudes comparatives</span>
        </li>
        <li className={subscription?.hasMarketResearch ? styles.active : ''}>
          <NavMarket />
          <span>Etudes de marché</span>
        </li>
        <li className={subscription?.hasActiveResearch ? styles.active : ''}>
          <NavSearches />
          <span>Recherches actives</span>
        </li>
        <li className={subscription?.hasGeolocation ? styles.active : ''}>
          <MapMarker />
          <span className="user-registration-text">
            Géolocalisation d&apos;annonce
          </span>
        </li>
      </ul>
    </div>
  );
}

export default SubscriptionContent;
